export const getIsNotificationClosed = (id, notifications) => {
    return notifications.some((notification) => notification.id === id);
};
